import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Post } from '../_models/post';

@Injectable({
  providedIn: 'root'
})
export class PostService {
  url = 'https://api.football-family.com/api/v1/';
  url2 = 'https://iffhs.com/api/v1/';
  url3 ="https://iffhs.com/api/v1/commentShow";
  url4 ="https://iffhs.com/api/v1/commentStore";
  //url2 = 'http://127.0.0.1:8000/api/v1/';
  //url3 ="http://127.0.0.1:8000/api/v1/commentShow";
  


  

  constructor(private http: HttpClient) { }


  getAll(data: any) {
    return this.http.post(this.url + 'showPosts', data);
  }
  getUserPhotos(data: any) {
    return this.http.post(this.url + 'showUserPhotos', data);
  }
  getUserVideos(data: any) {
    return this.http.post(this.url + 'showUserVideos', data);
  }
  getNewsFeed(data: any) {
    return this.http.post(this.url + 'feed', data);
  }
  getFrindVideos(data: any) {
    return this.http.post(this.url + 'friendVideos', data);
  }
  getFrindPhotos(data: any) {
    return this.http.post(this.url + 'friendPhotos', data);
  }
  getMyPhotos(data: any) {
    return this.http.post(this.url + 'getMyPhotos', data);
  }
  getIffhsPosts() {
    return this.http.post(this.url + 'showIffhsPosts', null);
  }
  getIffhsPosts2() {
    return this.http.post(this.url2 +'allPosts2', null);
  }
  getalliffhscommpost(data: any) {
    return this.http.post(this.url2 +'countcomments', data);
  }
  getSinglePost(data:any) {
    return this.http.post(this.url2 +'getpost', data);
  }
  getviewsPost(data:any) {
    return this.http.post(this.url2 +'showPostview', data);
  }
  getcommant(data:any) {
    return this.http.post(this.url3 , data);
  }

  putcommant(data:any) {
    return this.http.post(this.url4 , data);
  }
  getNewsAll() {
    return this.http.post(this.url + 'getNewsAll', null);
  }
  post(post: any) {
    return this.http.post(this.url + 'restPost', post);
  }
  postPhotoAlbum(post: any) {
    return this.http.post(this.url + 'photoAlbum', post);
  }

  updatePost(post: any) {
    return this.http.post(this.url + 'editPost', post);
  }

  comment(comment: any) {
    return this.http.post(this.url + 'comment', comment);
  }

  getAllComments(data: any) {
    return this.http.post(this.url + 'showComments', data);
  }

  likeUnlike(data: any) {
    return this.http.post(this.url + 'likeUnlike', data);
  }

  whoLikedMyPost(data: any) {
    return this.http.post(this.url + 'whoLikedMyPost', data);
  }

  unlike(data: any) {
    return this.http.post(this.url + 'unlikePost', data);
  }

  deletePost(data: any) {
    return this.http.post(this.url + 'deletePost', data);
  }

  deleteComment(data: any) {
    return this.http.post(this.url + 'deleteComment', data);
  }
  getfindfeed(data: any) {
    return this.http.post(this.url + 'findfeed', data);
  }
}
